<template>
  <form name="customer" class="needs-validation" novalidate>
    <div
      id="alert"
      class="alert alert-dismissible fade show m-alert m-alert--outline mb-4 mt-4"
      :class="alert.color"
      role="alert"
      v-if="alert.message"
      ref="alert"
    >
      <button type="button" class="close" aria-label="Close" @click="alert.message = ''"></button>
      <i :class="alert.icon"></i> &nbsp;<strong>{{ alert.message }}</strong
      ><br />
      {{ alert.reason }}
    </div>
    <div class="alert m-alert m-alert--default mb-3 mt-4" role="alert">
      <h5><i class="fas fa-info-circle"></i> Informações gerais</h5>
    </div>

    <div class="row mb-4">
      <div class="col-md-2" v-if="data.id">
        <label>ID</label>
        <div class="input-group">
          <input
            type="text"
            class="form-control"
            placeholder=""
            v-model="data.id"
            readonly="readonly"
          />
        </div>
      </div>
      <div class="col-md-5">
        <div class="form-group" :class="{ 'has-danger': !data.description }">
          <label for="co_name">Descrição <span class="m--font-danger">*</span></label>
          <div class="input-group">
            <input
              type="text"
              class="form-control m-input"
              name="description"
              id="description"
              placeholder=""
              v-model="data.description"
              required
            />
          </div>
        </div>
      </div>
      <div class="col-md-4">
        <div
          class="form-group"
          :class="{
            'has-danger': !data.document || (data.document && !validateCnpj(data.document) && !isAlphanumericCnpj(data.document)),
          }"
        >
          <label for="cnpj">Documento <span class="m--font-danger">*</span></label>
          <div class="input-group">
            <input
              type="text"
              class="form-control m-input"
              id="document"
              placeholder=""
              v-model="data.document"
              v-mask="'NN.NNN.NNN/NNNN-##'"
              @keyup="validateCnpj(data.document)"
              required
              :readonly="data.id"
            />
          </div>
        </div>
      </div>
    </div>
    <hr />
    <div class="alert m-alert m-alert--default mb-3 mt-4" role="alert">
      <h5><i class="fas fa-users"></i> Clientes</h5>
    </div>
    <div class="row">
      <div class="col-md-12">
        <div class="form-group" />

        <SelectCustomersMultiple @selected="selectedCustomer" ref="SelectCustomers" />
      </div>
    </div>
    <div class="table-responsive mt-4" v-if="data.id && data.details.length > 0">
      <div class="container-table">
        <table class="table table-striped- table-bordered table-hover table-checkable">
          <thead>
            <tr>
              <td nowrap class="text-center align-middle" width="200">ID Cliente</td>
              <td nowrap class="text-center align-middle" width="200">Cliente</td>
              <td nowrap class="text-center align-middle" width="150">Documento</td>
              <td nowrap class="text-center align-middle" width="80">Ações</td>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(detail, id) in data.details" :key="id">
              <td class="text-center align-middle">{{ detail.customer.id }}</td>
              <td class="text-center align-middle">{{ detail.customer.customerable.name }}</td>
              <td class="text-center align-middle">
                {{ detail.customer.documents.value | cnpj | cpf }}
              </td>
              <td nowrap class="text-center align-middle">
                <a
                  href="#"
                  @click.prevent.stop="confirmDel(detail.id)"
                  class="icon-circle ml-1"
                  v-b-tooltip.hover
                  title="Excluir"
                >
                  <i class="fas fa-trash-alt"></i>
                </a>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <hr class="row mt-5 mb-3" />
    <div class="row">
      <div class="col-md-12 text-right">
        <p class="p-0 m-0">
          <a
            href="#"
            @click.prevent="$refs.document.focus()"
            target="_self"
            class="m--font-danger"
            v-if="data.document && !validateCnpj(data.document) && !isAlphanumericCnpj(data.document)"
            ><strong>Documento</strong> inválido *</a
          >
        </p>
        <p class="p-0 m-0">
          <a
            href="#"
            @click.prevent="$refs.document.focus()"
            target="_self"
            class="m--font-danger"
            v-if="!data.document"
            >O campo <strong>Documento</strong> é obrigatório *</a
          >
        </p>
        <p class="p-0 m-0">
          <a
            href="#"
            @click.prevent="$refs.description.focus()"
            target="_self"
            class="m--font-danger"
            v-if="!data.description"
            >O campo <strong>Descrição</strong> é obrigatório *</a
          >
        </p>
      </div>
      <hr />
    </div>
    <div class="row mb-5">
      <div class="col-md-12 text-right">
        <button
          @click.prevent="saveForm()"
          class="btn"
          :class="{ 'btn-metal': !formIsValid, 'btn-focus': formIsValid }"
          :disabled="!formIsValid"
        >
          <i class="fas fa-save" v-if="formIsValid"></i>
          <i class="fas fa-exclamation-triangle" v-else></i>
          Salvar
        </button>
      </div>
    </div>
  </form>
</template>

<script>
import { baseApiUrl } from '@/global';
import axios from 'axios';
import { returnMessageFormMixin } from '@/mixins/returnMessageFormMixin.js';
import { validationMixin } from '@/mixins/validationMixin.js';
import SelectCustomersMultiple from '@/components/forms/SelectCustomersMultiple';

export default {
  mixins: [returnMessageFormMixin, validationMixin],
  name: 'CustomerGroupsSaveForm',
  components: { SelectCustomersMultiple },
  data() {
    return {
      data: {
        description: '',
        document: '',
        details: [],
        customersId: [],
      },
      alert: {
        color: 'alert-primary',
        icon: 'fas fa-spinner fa-spin fa-lg',
        message: '',
        reason: '',
      },
    };
  },
  methods: {
    removeCustomer($detailId) {
      const url = `${baseApiUrl}/v1/customer/group/detail/delete/${$detailId}`;
      axios
        .get(url)
        .then((res) => {
          this.logMessageForm(res);
          this.getDatas();
        })
        .catch((error) => this.logMessageFormFailed(error.response));
    },
    selectedCustomer(customersId) {
      this.data.customersIds = customersId.join(',');
    },
    async saveForm() {
      await this.messageWaitingSave();

      const alertEl = this.$refs.alert;
      if (alertEl) {
        alertEl.scrollIntoView();
      }

      const { data } = this;
      const url = `${baseApiUrl}/v1/customer/group/save`;
      axios
        .post(url, data)
        .then((res) => {
          this.logMessageForm(res);
          this.getDatas(res.data.item.id);
          this.$refs.SelectCustomers.items = [];
        })
        .catch((error) => this.logMessageFormFailed(error.response));
    },

    confirmDel(id) {
      this.dialog = '';
      this.$bvModal
        .msgBoxConfirm('Tem certeza que deseja desassociar este cliente ?', {
          size: 'md',
          contentClass: 'p-3',
          bodyClass: 'modal-body-fix',
          buttonSize: 'md',
          okVariant: 'danger',
          okTitle: 'Confirmar',
          cancelTitle: 'Cancelar',
          cancelVariant: 'metal',
          footerClass: 'p-4',
          hideHeaderClose: true,
          centered: true,
        })
        .then((value) => {
          if (value == true) {
            this.removeCustomer(id);
          }
        })
        .catch((error) => {
          this.logMessageFailed(error.response);
        });
    },
    getDatas(insertedGroupId = null) {
      const url = `${baseApiUrl}/v1/customer/group/data/${
        insertedGroupId ? insertedGroupId : this.customerGroupId
      }`;
      axios(url).then((res) => {
        this.data = res.data;
      });
    },
    callData() {
      this.getDatas();
    },
    onChangeStatus(status) {
      this.data.status = status;
      this.data.status_reason = '';
    },
  },
  computed: {
    customerGroupId() {
      return this.$store.state.showCustomerGroupSave;
    },
    action() {
      return this.$store.state.showActionCustomerGroupSave;
    },
    formIsValid() {
      if (this.data.description && this.data.document) {
        return true;
      }
      return false;
    },
  },
  beforeMount() {
    if (this.action && this.customerGroupId !== 'add') {
      this.callData();
    }
  },
};
</script>

<style>
.list-group {
  width: 50%;
  float: left;
}
.list-group b {
  display: block;
}
.card {
  border: none;
}

.m-quick-sidebar-overlay {
  background: rgba(0, 0, 0, 0.3);
}

@media (min-width: 1201px) {
  #m_quick_sidebar {
    width: 50% !important;
  }
}

@media (min-width: 601px) and (max-width: 1200px) {
  #m_quick_sidebar {
    width: 60% !important;
  }
}

@media (max-width: 600px) {
  #m_quick_sidebar {
    width: 100% !important;
  }
}
</style>
